import { getTime } from "./time";
import { RetrieveService } from "./RevrieveService";

const API = {
  getTime,
  RetrieveService,
};
export default API;
